import React, { useState } from 'react';

import ValidationAlert from '../../../app/components/ValidationAlert';
import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import {
  GetPaymentDto,
  ResponseError,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { SellDocumentType } from '../../../common/spdCore/validation/schemas';
import { parse, subtract } from '../../../utils/mathUtils';

interface CreateSalesInvoiceFromPaymentButtonProps {
  payment: GetPaymentDto;
}

export const CreateSalesInvoiceFromPaymentButton: React.FC<
  CreateSalesInvoiceFromPaymentButtonProps
> = ({ payment }) => {
  const spd = useSpdCore();
  const nav = useNavigation();
  const [showError, setShowError] = useState(false);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);

  if (
    !payment.visit?.exam?.examined?.id ||
    payment.visit?.sellDocumentType !== SellDocumentType.Faktura.toString()
  ) {
    return null;
  }

  const invoicedAmount = parse(payment.sellInvoiceAmount);
  const remaining = subtract(payment.amount, invoicedAmount);
  if (remaining <= 0) {
    return null;
  }

  const handleCreate = async () => {
    try {
      const createdInvoice = await spd.salesInvoices.createFromPayment(
        payment.id,
      );
      nav.salesInvoiceEditor(createdInvoice.id);
    } catch (response) {
      const errors = await responseErrors(response as ResponseError);
      setErrorMessages(errors);
      setShowError(true);
    }
  };

  return (
    <div
      role="presentation"
      onClick={e => e.stopPropagation()}
      onKeyDown={e => e.stopPropagation()}
    >
      <ValidationAlert
        show={showError}
        modal={true}
        onHide={() => setShowError(false)}
        errors={errorMessages}
      />
      <ConfirmationButton
        confirmation="Czy chcesz wystawić fakturę dla tej płatności?"
        variant="outline-primary"
        onOK={handleCreate}
      >
        Wystaw fakturę
      </ConfirmationButton>
    </div>
  );
};
